import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRateIndexControlMainPanel extends Layout {
    defaultPanel: Panel;
    mainPanel: Panel;
    sourceRateIndexControl: DataSource;
    textboxDashboardUrl: Textbox;
    textboxIntegrationId: Textbox;
    textboxPassword: Textbox;
    textboxUserName: Textbox;
    textboxWebServiceUrl: Textbox;
}
